const STORAGE_KEY = "ff_analytics_checkout_attempt";

function readRecord() {
  if (typeof sessionStorage === "undefined") {
    return null;
  }
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.id || !parsed.listing_id) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

function writeRecord(record) {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch {
    // ignore
  }
}

function clearRecord() {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

function newId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `attempt-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

/** Returns attempt id the first time checkout_started should fire; null afterward. */
export function markCheckoutStarted(listingId) {
  if (!listingId) {
    return null;
  }
  let record = readRecord();
  if (!record || record.listing_id !== listingId) {
    record = { id: newId(), listing_id: listingId, started: false };
  }
  if (record.started) {
    return null;
  }
  record.started = true;
  writeRecord(record);
  return record.id;
}

/** Call when a queued begin_checkout is dropped so the next payable view can emit again. */
export function unmarkCheckoutStarted(listingId) {
  const record = readRecord();
  if (!record || !record.started) {
    return;
  }
  if (listingId && record.listing_id !== listingId) {
    return;
  }
  record.started = false;
  writeRecord(record);
}

export function getCheckoutAttemptId(listingId) {
  const record = readRecord();
  if (!record || record.listing_id !== listingId) {
    return null;
  }
  return record.id;
}

export function closeCheckoutAttemptIfLeaving(pageType) {
  if (pageType !== "ticket" && pageType !== "checkout") {
    clearRecord();
  }
}

export function _clearCheckoutAttemptForTests() {
  clearRecord();
}
